import React, { createContext, useContext, useEffect, useState } from 'react';
import {jwtDecode} from 'jwt-decode';
import http from '../service/http';
import { apis } from '../service/APIS';

// Create the context
const UserContext = createContext();

// User provider component
export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Load user from decoded token
    const loadUser = () => {
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setUser(decoded);
            } catch (err) {
                setError("Failed to decode token");
                console.error("Token decoding error:", err);
            } finally {
                setLoading(false);
            }
        } else {
            setLoading(false);
        }
    };

    // Logout user
    const logout = async () => {
        setUser(null);
        await http.post(apis.logout, {
            refresh: localStorage.getItem('refresh')
        })
        localStorage.removeItem('token');
        localStorage.removeItem('refresh');
    };

    // Use effect to load the user when the component mounts
    useEffect(() => {
        loadUser();
    }, []);

    return (
        <UserContext.Provider value={{ user, loading, error, reloadUser: loadUser, logout }}>
            {children}
        </UserContext.Provider>
    );
};

// Custom hook to use the User context
export const useUser = () => {
    return useContext(UserContext);
};
